import { validateEmail } from '@revenuemarket/utils';
import * as yup from 'yup';

// 비밀번호 검증 함수
const validatePassword = (password: string): boolean => {
  if (!password) return false;

  const hasLetter = /[a-zA-Z]/.test(password);
  const hasNumber = /[0-9]/.test(password);
  const hasSpecialChar = /[^a-zA-Z0-9]/.test(password);

  const typeCount = [hasLetter, hasNumber, hasSpecialChar].filter(Boolean).length;

  // 3종류 이상 + 8자 이상
  if (typeCount >= 3 && password.length >= 8) {
    return true;
  }

  // 2종류 이상 + 10자 이상
  if (typeCount >= 2 && password.length >= 10) {
    return true;
  }

  return false;
};

export const COMMON_YUP = {
  email: yup
    .string()
    .required('이메일을 입력해주세요.')
    .test('format', '이메일 형식에 맞춰 입력해주세요.', (value) => {
      if (value) {
        return validateEmail(value);
      }
      return false;
    }),
  phoneNumber: yup
    .string()
    .required('휴대폰 번호를 입력해주세요.')
    .min(11, '휴대폰 번호 11자리를 입력해주세요.')
    .max(11, '휴대폰 번호 11자리를 입력해주세요.'),
  // @deprecated
  legacyPassword: yup
    .string()
    .required('비밀번호를 입력해주세요.')
    .min(8, '8자 이상의 비밀번호를 입력해주세요.'),
  // @deprecated
  legacyPasswordConfirm: yup
    .string()
    .required('비밀번호를 입력해주세요.')
    .min(8, '8자 이상의 비밀번호를 입력해주세요.')
    .oneOf([yup.ref('password')], '비밀번호와 일치하지 않습니다.'),
  password: yup
    .string()
    .required('비밀번호를 입력해주세요.')
    .test(
      'password-complexity',
      '영문, 숫자, 특수문자 중 2종류 이상을 조합하여 최소 10자리 이상 또는 3종류 이상을 조합하여 최소 8자리 이상의 길이로 구성해주세요.',
      (value) => {
        if (!value) return false;
        return validatePassword(value);
      },
    ),
  passwordConfirm: yup
    .string()
    .required('비밀번호를 입력해주세요.')
    .oneOf([yup.ref('password')], '비밀번호와 일치하지 않습니다.'),
};
